import React, { useEffect } from "react";
import StorageUploader from "../Uploader";

const UploadModal = ({ isOpen, folder, toggleModal, Uploader = StorageUploader }) => {
  const onKeyDown = (event) => {
    const e = event || window.event;
    if (e.keyCode === 27) {
      toggleModal(false);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`modal ${isOpen ? "is-active" : ""} upload-modal`}>
      <div className="modal-background"></div>
      <div className="modal-content upload-modal-content-container">
        <div className="upload-modal-content-border">
          <div className="upload-modal-content-upload">
            <span className="icon has-text-primary">
              <i className="fas fa-cloud-upload-alt fa-lg"></i>
            </span>
            <h2 className="is-size-2">Upload Files Here</h2>
            click below to
            <Uploader folder={folder} />
          </div>
        </div>
      </div>
      <button className="modal-close is-large" aria-label="close" onClick={() => toggleModal(false)}></button>
    </div>
  );
};

export default UploadModal;
